import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(): boolean {
    if (localStorage.getItem('token') && localStorage.getItem('data')) {
      return true;
    }
    this.router.navigate(['/']);
    return false;
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/guards/auth.guard.ts